var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.533,
    height: 21.437,
    viewBox: "0 0 21.533 21.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_95_",
    transform: "translate(0 -1.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_98_",
    d: "M8.941,303.261q-.137.012-.274.012a3.239,3.239,0,0,1-.732-.091L2.419,308.7a.693.693,0,0,0,0,.98L3.846,311.1a.693.693,0,0,0,.979,0l6.629-6.628-1.229-1.326Z",
    transform: "translate(-2.118 -288.767)",
    fill: "#c2c3cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_97_",
    d: "M259.306,5.656a.662.662,0,0,0-.937,0L254.8,9.231a.865.865,0,1,1-1.224-1.223l3.557-3.556a.689.689,0,0,0-.975-.975L252.6,7.033a.865.865,0,0,1-1.224-1.223l3.574-3.574a.663.663,0,0,0-.938-.938l-4.021,4.021a3.717,3.717,0,0,0-.959,3.561l2.7,2.7a3.717,3.717,0,0,0,3.56-.96l4.022-4.021A.663.663,0,0,0,259.306,5.656Z",
    transform: "translate(-237.967)",
    fill: "#c2c3cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_96_",
    d: "M1.807,9.15a.729.729,0,0,0-.515-.213.74.74,0,0,0-.122.01.729.729,0,0,0-.535.4,6.354,6.354,0,0,0,1.226,7.26l3.421,3.42a1.79,1.79,0,0,0,1.267.525q.076,0,.152-.006l1.986-.169,8.66,9.342a.73.73,0,0,0,.521.233h.013a.734.734,0,0,0,.518-.213l1.483-1.483a.73.73,0,0,0,0-1.032Z",
    transform: "translate(0 -7.489)",
    fill: "#c2c3cc"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.654d23f3f8537763fff92e64c9bdc5b2.svg";
export { ForwardRef as ReactComponent };